import { WSText } from "@wingspanhq/fe-component-library";
import { VerificationStatus } from "@wingspanhq/payments/dist/interfaces";
import { AxiosError } from "axios";
import React, { useEffect } from "react";
import { OverlaySpinner } from "../../../components/OverlaySpinner";
import { SetupFlowRouteComponentProps } from "../../../components/SetupFlow/SetupFlow";
import { useWSMutation } from "../../../query/helpers";
import { useUserId } from "../../../query/hooks/helpers";
import { QUERY_PAYMENTS_STATUS } from "../../../query/payments/keys";
import { paymentsService } from "../../../services/payments";
import { PaymentsSetupLayout } from "../../components/PaymentsSetupLayout/PaymentsSetupLayout";
import { SetupInternationalAccount } from "../../components/SetupInternationalAccount/SetupInternationalAccount";

export const SetupPayoutsInternational: React.FC<SetupFlowRouteComponentProps> = ({
  onBack,
  onNext
}) => {
  const userId = useUserId();

  const [enablePayments, enablePaymentsMeta] = useWSMutation<any, AxiosError>(
    () => {
      return paymentsService.service.update(userId, {
        verifications: {
          taxDocumentation: VerificationStatus.Verified,
          banking: VerificationStatus.Verified
        }
      });
    },
    {
      dependencies: [QUERY_PAYMENTS_STATUS]
    }
  );

  useEffect(() => {
    enablePayments();
  }, []);

  return (
    <PaymentsSetupLayout onBack={onBack}>
      <WSText.Heading2 mb="XS">Direct deposit</WSText.Heading2>
      <WSText mb="M">
        We saved the best for last: tell us where to deposit your funds.
      </WSText>

      <SetupInternationalAccount onSubmit={onNext} />

      {enablePaymentsMeta.isLoading && <OverlaySpinner />}
    </PaymentsSetupLayout>
  );
};
